var map = {
	"./baac.svg": 338,
	"./bay.svg": 339,
	"./bbl.svg": 340,
	"./bnp.svg": 341,
	"./boc.svg": 342,
	"./bofa.svg": 343,
	"./cacib.svg": 344,
	"./cimb.svg": 345,
	"./citi.svg": 346,
	"./db.svg": 347,
	"./gh.svg": 348,
	"./gsb.svg": 349,
	"./hsbc.svg": 350,
	"./ibank.svg": 351,
	"./icbc.svg": 352,
	"./jpm.svg": 353,
	"./kbank.svg": 354,
	"./kk.svg": 355,
	"./ktb.svg": 356,
	"./lh.svg": 357,
	"./mb.svg": 358,
	"./mufg.svg": 359,
	"./rbs.svg": 360,
	"./sc.svg": 361,
	"./scb.svg": 362,
	"./smbc.svg": 363,
	"./tbank.svg": 364,
	"./tcrb.svg": 365,
	"./tisco.svg": 366,
	"./tmb.svg": 367,
	"./ttb.svg": 368,
	"./uobt.svg": 369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 175;